// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchNroCliente_searchContainer__zYmYs","modalContent":"SearchNroCliente_modalContent__3TIil","btnVolver":"SearchNroCliente_btnVolver__tY0dL"};